module.exports = __webpack_public_path__ + "static/media/product-bakground-shade.c1bde4eb.svg";